<div [id]="field.attributes.id" (blur)="touch()">
  @for (group of groups; track group) {
  <div class="group">
    <div class="head">
      {{ group.name }}
      <input
        type="checkbox"
        [ngModel]="areAllChecked(group)"
        (ngModelChange)="toggleAll(group)"
      />
    </div>
    @for (option of group.options; track option) {
    <div class="option">
      <label>
        <span>{{ option.name }}</span>
        <input
          type="checkbox"
          [(checklist)]="value"
          [checklistValue]="option.id"
        />
      </label>
    </div>
    }
  </div>
  }
</div>
